<template>
  <el-dialog :title="title" :visible.sync="visible" width="560px" @closed="resetForm">
    <div class="param-danger" style="background:#fff1f0;border:1px solid #ffa39e;color:#cf1322;border-radius:6px;padding:8px 12px;margin-bottom:12px;font-size:13px;line-height:1.6;">
      <b>⚠ 危险参数，请勿随意修改！</b><br>
      本表单定义支付厂家的代码实现（Spring Bean）。Bean 名称必须与后端实际存在的实现类一致，
      填错会直接导致该厂家无法支付 / 退款。
    </div>
    <el-form ref="form" :model="form" label-width="130px" :rules="rules">
      <el-form-item :label="$t('paymentAdapt.vendorType')" prop="paymentType">
        <el-input v-model="form.paymentType" :placeholder="$t('paymentAdapt.paymentTypePlaceholder')"
          :disabled="isEdit" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">厂家唯一标识（如 WECHAT / FUIOU / PLUTUS）。保存后不可修改，后端代码按此标识调用对应支付实现。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.vendorName')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('paymentAdapt.namePlaceholder')" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">展示名称：业主端支付方式列表、小区支付配置下拉框显示用。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.beanJsapi')" prop="beanJsapi">
        <el-input v-model="form.beanJsapi" :placeholder="$t('paymentAdapt.beanPlaceholder')" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">JSAPI 支付实现类（Spring Bean），必填。业主端 H5 / 小程序支付统一下单调用；必须是系统已存在的实现类（如 wechatPaymentFactory）。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.beanQrcode')">
        <el-input v-model="form.beanQrcode" :placeholder="$t('paymentAdapt.beanPlaceholder')" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">扫码支付（被扫）实现类，不使用可留空。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.beanNative')">
        <el-input v-model="form.beanNative" :placeholder="$t('paymentAdapt.beanPlaceholder')" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">NATIVE 扫码（主扫，商户被扫）实现类，不使用可留空。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.beanRefund')">
        <el-input v-model="form.beanRefund" :placeholder="$t('paymentAdapt.beanPlaceholder')" />
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:4px;">退款实现类，留空则该厂家不支持在线退款（退款会失败）。</div>
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.status')" prop="statusCd">
        <div class="param-tip" style="font-size:12px;color:#909399;line-height:1.5;margin-top:-6px;margin-bottom:6px;">停用后小区支付配置页下拉框不再出现该厂家；已有配置不受影响。</div>
        <el-radio-group v-model="form.statusCd">
          <el-radio label="0">{{ $t('paymentAdapt.enabled') }}</el-radio>
          <el-radio label="1">{{ $t('paymentAdapt.disabled') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePaymentAdapt, updatePaymentAdapt } from '@/api/system/paymentAdaptApi'

export default {
  name: 'AddPaymentAdapt',
  data() {
    return {
      visible: false,
      isEdit: false,
      submitting: false,
      form: {
        adaptId: '',
        paymentType: '',
        name: '',
        beanJsapi: '',
        beanQrcode: '',
        beanNative: '',
        beanRefund: '',
        statusCd: '0'
      },
      rules: {
        paymentType: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'blur' },
          { max: 64, message: this.$t('paymentAdapt.maxLength64'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'blur' },
          { max: 64, message: this.$t('paymentAdapt.maxLength64'), trigger: 'blur' }
        ],
        beanJsapi: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'blur' },
          { max: 64, message: this.$t('paymentAdapt.maxLength64'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      return this.isEdit ? this.$t('paymentAdapt.edit') : this.$t('paymentAdapt.add')
    }
  },
  methods: {
    open(row) {
      this.resetForm()
      if (row && row.adaptId) {
        this.isEdit = true
        this.form = {
          adaptId: row.adaptId,
          paymentType: row.paymentType,
          name: row.name,
          beanJsapi: row.beanJsapi,
          beanQrcode: row.beanQrcode || '',
          beanNative: row.beanNative || '',
          beanRefund: row.beanRefund || '',
          statusCd: row.statusCd || '0'
        }
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    resetForm() {
      this.isEdit = false
      this.form = {
        adaptId: '',
        paymentType: '',
        name: '',
        beanJsapi: '',
        beanQrcode: '',
        beanNative: '',
        beanRefund: '',
        statusCd: '0'
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await updatePaymentAdapt(this.form)
          } else {
            await savePaymentAdapt(this.form)
          }
          this.$message.success(this.$t('common.saveSuccess'))
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || this.$t('common.saveFail'))
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>
